<template>
	<div class="container">
		<div class="header">
			<div class="title">配置微信商户号</div>
			<p class="remark">社群拍档作为微信支付服务商，代商户申请微信支付账号</p>
		</div>
		<div class="step-block">
			<el-steps :active="step" finish-status="success">
				<el-step title="主体资料"></el-step>
				<el-step title="经营资料"></el-step>
				<el-step title="结算信息"></el-step>
			</el-steps>
		</div>
		<div class="forms">
			<div class="form-title">
				<p>{{stepTitles[step]}}</p>
			</div>
			<template v-if="step == 0">
				<el-form class="form1" ref="form1" :model="form">
					<el-form-item label="主体类型" required>
						<el-select v-model="form.subject_type" placeholder="请选择主体类型">
							<el-option 
							  v-for="(item, index) in selector_data.subject_type"
							  :key="index"
							  :label="item.name"
							  :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="统一社会信用代码" required>
						<el-input v-model="form.license_number" @input="vInput($event, 'license_number')" maxlength="18" placeholder="请输入社会信用代码"></el-input>
					</el-form-item>
					<el-form-item label="主体名称" required>
						<el-input v-model="form.subject_name" @input="vInput($event, 'subject_name')" maxlength="50" placeholder="请输入企业主体名称"></el-input>
					</el-form-item>
					<el-form-item style="align-items: flex-start;" label="营业执照" required>
						<div>
							<el-upload class="el-upload-1" ref="uploadLicense" :action="upload.url"
								:headers="upload.headers" :show-file-list="false" :on-success="uploadSuccess1"
								:before-upload="beforeUpload">
								<div class="el-upload-1-item" v-if="!form.license_id">
									<i class="el-icon-plus"></i>
								</div>
								<img :src="form.license_url" class="el-upload-1-img" v-else>
							</el-upload>
							<p class="el-upload-tip">只能上传jpg/png图片文件，且不超过2M</p>
						</div>
					</el-form-item>
					<el-form-item label="法人姓名" required>
						<el-input v-model="form.person_name" @input="vInput($event, 'person_name')" maxlength="20" placeholder="请输入企业法人姓名"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" required>
						<el-input v-model="form.person_idcard" @input="vInput($event, 'person_idcard')" maxlength="18" placeholder="请输入企业法人身份证号"></el-input>
					</el-form-item>
					<el-form-item label="身份证有效期开始日期" required>
						<el-date-picker
						  v-model="form.person_idcard_start"
						  type="date"
						  placeholder="请输入身份证有效期开始日期"
						  value-format="yyyy-MM-dd"
						  :picker-options="dateOption">
						</el-date-picker>
					</el-form-item>
					<el-form-item style="align-items: flex-start;" label="身份证有效期结束日期" required>
						<el-date-picker
						  v-model="form.person_idcard_end"
						  type="date"
						  placeholder="请输入身份证有效期结束日期"
						  value-format="yyyy-MM-dd"
						  :disabled="form.person_idcard_end_is_long"
						  style="margin-right: 15px;">
						</el-date-picker>
						<el-checkbox border v-model="form.person_idcard_end_is_long" label="长期"></el-checkbox>
						<p class="el-upload-tip">无结束日期请勾选长期</p>
					</el-form-item>
					<el-form-item style="align-items: flex-start;" label="法人身份证照片" required>
						<div style="display: flex;">
							<div>
								<el-upload class="el-upload-2" ref="uploadIdcardFront" :action="upload.url"
									:headers="upload.headers" :show-file-list="false" :on-success="uploadSuccess2"
									:before-upload="beforeUpload">
									<div class="el-upload-2-item" v-if="!form.person_idcard_front_id">
										<img src="../../assets/img/pay/idcard_front.png" alt="">
									</div>
									<img :src="form.person_idcard_front_url" class="el-upload-2-img" v-else>
								</el-upload>
								<p class="el-upload-tip">只能上传jpg/png图片文件，且不超过2M</p>
							</div>
							<div>
								<el-upload class="el-upload-2" ref="uploadIdcardBack" :action="upload.url"
									:headers="upload.headers" :show-file-list="false" :on-success="uploadSuccess3"
									:before-upload="beforeUpload">
									<div class="el-upload-2-item" v-if="!form.person_idcard_back_id">
										<img src="../../assets/img/pay/idcard_back.png" alt="">
									</div>
									<img :src="form.person_idcard_back_url" class="el-upload-2-img" v-else>
								</el-upload>
							</div>
						</div>
					</el-form-item>
					<el-form-item style="margin-top: 60px;">
						<el-button type="primary" @click="nextStep">下一步</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template v-else-if="step == 1">
				<el-form class="form2" ref="form2" :model="form">
					<el-form-item label="商户简称" required>
						<el-input v-model="form.busi_name" @input="vInput($event, 'busi_name')" maxlength="50" placeholder="请输入商户简称"></el-input>
					</el-form-item>
					<el-form-item label="客服电话" required>
						<el-input v-model="form.kf_phone" @input="vInput($event, 'kf_phone')" maxlength="20" placeholder="请输入客服电话"></el-input>
					</el-form-item>
					<el-form-item label="管理员身份" required>
						<el-radio v-model="form.admin_type" label="LEGAL">法定代表人/经营者</el-radio>
						<el-radio v-model="form.admin_type" label="SUPER">负责人</el-radio>
					</el-form-item>
					<el-form-item label="管理员姓名" required>
						<template v-if="form.admin_type == 'LEGAL'">
							<p>{{form.person_name}}</p>
						</template>
						<template v-else>
							<el-input v-model="form.admin_name" @input="vInput($event, 'admin_name')" maxlength="20" placeholder="请输入超级管理员真实姓名"></el-input>
						</template>
					</el-form-item>
					<el-form-item label="身份证号" required>
						<template v-if="form.admin_type == 'LEGAL'">
							<p>{{form.person_idcard}}</p>
						</template>
						<template v-else>
							<el-input v-model="form.admin_idcard" @input="vInput($event, 'admin_idcard')" maxlength="18" placeholder="请输入管理员身份证号"></el-input>
						</template>
					</el-form-item>
					<el-form-item label="联系电话" required>
						<el-input v-model="form.admin_phone" @input="vInput($event, 'admin_phone')" maxlength="20" placeholder="请输入管理员联系电话"></el-input>
					</el-form-item>
					<el-form-item label="联系邮箱" required>
						<el-input v-model="form.admin_email" @input="vInput($event, 'admin_email')" maxlength="50" placeholder="请输入联系邮箱地址"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 60px;">
						<el-button @click="prevStep">上一步</el-button>
						<el-button type="primary" @click="nextStep">下一步</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template v-else-if="step == 2">
				<el-form class="form3" ref="form3" :model="form">
					<el-form-item label="开户名称" required>
						<p>{{form.subject_name}}</p>
					</el-form-item>
					<el-form-item label="开户银行" required>
						<el-select v-model="form.account_bank_name" placeholder="请选择开户银行" @change="changeBank">
							<el-option
							  v-for="(item, index) in selector_data.account_bank_name"
							  :label="item.value"
							  :value="item.value_id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开户行地区" required>
						<el-select v-model="form.account_area[0]" placeholder="所在省" class="short-input" @change="changeArea0">
						    <el-option
						      v-for="item in selector_data.account_area0"
						      :key="item.value_id"
						      :label="item.value"
						      :value="item.value_id">
						    </el-option>
						</el-select>
						<el-select v-model="form.account_area[1]" placeholder="所在市" class="short-input" @change="changeArea1">
						    <el-option
						      v-for="item in selector_data.account_area1"
						      :key="item.value_id"
						      :label="item.value"
						      :value="item.value_id">
						    </el-option>
						</el-select>
						<el-select v-model="form.account_area[2]" placeholder="所在区" class="short-input">
						    <el-option
						      v-for="item in selector_data.account_area2"
						      :key="item.value_id"
						      :label="item.value"
						      :value="item.value_id">
						    </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开户行全称（含支行）" required>
						<el-autocomplete
						  class="inline-input"
						  v-model="form.account_bank_fullname" @input="vInput($event, 'account_bank_fullname')"
						  placeholder="请输入开户银行全称"
						  :fetch-suggestions="querySearch"
						  :trigger-on-focus="false"
						></el-autocomplete>
					</el-form-item>
					<el-form-item label="银行账号" required>
						<el-input v-model="form.account_bank_no" @input="vInput($event, 'account_bank_no')" maxlength="19" placeholder="请输入银行账号"></el-input>
					</el-form-item>
				</el-form>
				<div class="form-title">
					<p>{{stepTitles[step + 1]}}</p>
				</div>
				<el-form class="form4" ref="form4" :model="form">
					<el-form-item label="所属行业" required>
						<el-select v-model="form.industry" placeholder="请选择所属行业" @change="changeIndustry">
							<el-option
							  v-for="(item, index) in selector_data.industry"
							  :label="item.value"
							  :value="item.value_id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="结算规则" required>
						<p v-if="form.indset.rule_doc">{{form.indset.rule_doc}}</p>
						<p v-else>所属行业的结算规则</p>
					</el-form-item>
					<el-form-item label="特殊资质" :required="form.indset.is_quali > 0">
						<div>
							<el-upload class="el-upload-3" :class="{'el-upload-hide': fileList.length > 4}" ref="uploadQual"
								:headers="upload.headers" :action="upload.url" :file-list="fileList"
								list-type="picture-card" :on-success="uploadSuccess4" :multiple="true" :limit="5"
								:on-preview="previewImage" :before-upload="beforeMultipleUpload"
								:on-remove="uploadRemove">
								<div class="el-upload-3-item">
									<i class="el-icon-plus"></i>
								</div>
							</el-upload>
						</div>
						<div class="el-upload-tip" v-if="form.indset.quali_doc != ''">
							<p>{{form.indset.quali_doc}}</p>
						</div>
					</el-form-item>
					<el-form-item style="margin-top: 60px;">
						<el-button @click="prevStep">上一步</el-button>
						<el-button type="primary" @click="nextStep">提交审核</el-button>
					</el-form-item>
				</el-form>
			</template>
		</div>
		
		<el-dialog width="540px" :visible.sync="showPreview" :before-close="closePreview">
			<img :src="previewImageUrl" style="width: 500px;height: 480px;object-fit: contain;" height="auto" />
		</el-dialog>
	</div>
</template>

<script>
	import {
		handleCode
	} from '@/utils/request';
	import {
		getSelectorData,
		applyment,
		editApplyment
	} from '../../api/pay';
	import oss from '@/utils/oss';
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	let id = 0;
	export default {
		data() {
			return {
				step: 0,
				stepTitles: ['主体资料', '经营与管理资料', '结算银行账户', '结算规则'],
				upload: {
					// 请求头
					headers: {authorization: this.$store.getters['user/accessToken']},
					// 上传地址
					url: baseURL + '/api/brand.Upload/oneToOss'
				},
				previewImageUrl: '',
				showPreview: false,
				
				fileList: [],
				form: {
					subject_type: 'SUBJECT_TYPE_ENTERPRISE',
					subject_name: '',
					license_number: '',
					license_id: '',
					license_url: '',
					person_name: '',
					person_idcard: '',
					person_idcard_start: '',
					person_idcard_end: '',
					person_idcard_end_is_long: false,
					person_idcard_front_id: '',
					person_idcard_front_url: '',
					person_idcard_back_id: '',
					person_idcard_back_url: '',
					busi_name: '',
					kf_phone: '',
					admin_type: 'LEGAL',
					admin_name: '',
					admin_idcard: '',
					admin_phone: '',
					admin_email: '',
					account_bank_name: '',
					account_area: ['','',''],
					account_bank_fullname: '',
					account_bank_no: '',
					industry: '',
					indset: {},
					qual: [],
				},
				selector_data: {
					subject_type: [],
					account_bank_name: [],
					account_bank_fullname: [],
					account_area0: [],
					account_area1: [],
					account_area2: [],
					industry: []
				},
				dateOption: {
					disabledDate(time) {
					  return time.getTime() > Date.now();
					},
				}
			}
		},
		mounted() {
			document.getElementsByClassName("father-main")[0].scrollTop = 0;
			let query = this.$route.query;
			if (query.edit == 1) {
				this.editApplyment();
			}
			this.getData('subject_type');
			this.getData('account_bank_name');
			this.getData('industry');
			this.getArea(0, 0);
		},
		methods: {
			vInput(value, model, rule) {
				value = '' + value;
				value = value.replace(/\s/g, "");
				if (rule) {
					switch (rule) {
						case 'tel':
						
							break;
						case 'idcard':
						
							break;
						case 'email':
						
							break;
					}
				}
				this.form[model] = value;
			},
			getData(data_name, data_id) {
				getSelectorData({
					data_name: data_name,
					data_id: data_id
				}).then(res => {
					if (res.code == 0) {
						this.selector_data[data_name] = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getArea(level, data_id) {
				getSelectorData({
					data_name: 'account_area',
					data_id: data_id
				}).then(res => {
					if (res.code == 0) {
						this.selector_data['account_area' + level] = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getIndset() {
				getSelectorData({
					data_name: 'indset',
					data_id: this.form.industry,
					subject_type: this.form.subject_type
				}).then(res => {
					if (res.code == 0) {
						var data = res.data;
						this.form.indset = data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			editApplyment() {
				editApplyment({
					
				}).then(res => {
					if (res.code == 0) {
						this.form = res.data;
						this.fileList = res.data.qual_url;
						this.getArea(1, res.data.account_area[0]);
						this.getArea(2, res.data.account_area[1]);
						this.getData('account_bank_fullname', res.data.account_bank_name);
					} else {
						this.$message.error(res.message);
					}
				})
			},
			changeIndustry(value) {
				if (value > 0) {
					this.getIndset();
				}
			},
			changeArea0(value) {
				this.form.account_area[1] = '';
				this.form.account_area[2] = '';
				this.getArea(1, value);
			},
			changeArea1(value) {
				this.form.account_area[2] = '';
				this.getArea(2, value);
			},
			changeBank(value) {
				this.getData('account_bank_fullname', value);
			},
			querySearch(queryString, cb) {
				var querys = this.selector_data.account_bank_fullname;
				var results = queryString ? querys.filter(this.createFilter(queryString)) : querys;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
				  return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			// 验证用户上传的图片格式和大小
			beforeUpload(file) {
				if (['image/jpeg', 'image/png'].indexOf(file.type) === -1) {
					this.$message.error('上传图片仅支持 JPG/PNG 格式');
					return false;
				}
				if (file.size / 1024 / 1024 > 2) {
					this.$message.error('上传图片单张大小不能超过 2MB');
					return false;
				}
				return true;
			},
			// 验证图片上传（批量）的格式和大小
			beforeMultipleUpload(file) {
				if (this.form.qual.length > 4) {
					this.$message.error('最多可上传5张图片');
					return false;
				}
				if (['image/jpeg', 'image/png'].indexOf(file.type) === -1) {
					this.$message.error('上传图片仅支持 JPG/PNG 格式');
					return false;
				}
				if (file.size / 1024 / 1024 > 2) {
					this.$message.error('上传图片单张大小不能超过 2MB');
					return false;
				}
				return true;
			},
			// 营业执照上传完成
			uploadSuccess1(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					this.form.license_url = response.data.url;
					this.form.license_id = response.data.id;
				}
				this.$refs.uploadLicense.clearFiles(); //上传成功之后清除上传记录
			},
			// 法人身份证正面照上传完成
			uploadSuccess2(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					this.form.person_idcard_front_url = response.data.url;
					this.form.person_idcard_front_id = response.data.id;
				}
				this.$refs.uploadIdcardFront.clearFiles(); //上传成功之后清除上传记录
			},
			// 法人身份证反面照上传完成
			uploadSuccess3(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					this.form.person_idcard_back_url = response.data.url;
					this.form.person_idcard_back_id = response.data.id;
				}
				this.$refs.uploadIdcardBack.clearFiles(); //上传成功之后清除上传记录
			},
			// 特殊资质上传完成
			uploadSuccess4(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					fileList.forEach((item) => {
						if (item.uid == file.uid) {
							item.url = response.data.url
						}
					})
					this.fileList = fileList;
					this.form.qual.push(response.data.id);
				}
				this.$refs.uploadQual.clearFiles(); //上传成功之后清除上传记录
			},
			//删除图片
			uploadRemove(file, fileList) {
				let index = this.fileList.findIndex(item => {
					return file.url === item.url
				})
				this.fileList = fileList;
				this.form.qual.splice(index, 1);
			},
			// 预览图片
			previewImage(file) {
				this.previewImageUrl = file.url;
				this.showPreview = true;
			},
			// 关闭预览
			closePreview(done) {
				done();
				this.previewImageUrl = '';
			},
			nextStep() {
				//检测必填项
				if (this.step == 0) {
					if (this.form.subject_type == '') {
						this.$message.error('请选择主体类型');
						return false;
					}
					if (this.form.license_number == '') {
						this.$message.error('请输入社会信用代码');
						return false;
					}
					if (this.form.subject_name == '') {
						this.$message.error('请输入企业主体名称');
						return false;
					}
					if (this.form.license_id == '') {
						this.$message.error('请上传营业执照');
						return false;
					}
					if (this.form.person_name == '') {
						this.$message.error('请输入企业法人姓名');
						return false;
					}
					if (this.form.person_idcard == '') {
						this.$message.error('请输入企业法人身份证号');
						return false;
					}
					if (this.form.person_idcard_start == '') {
						this.$message.error('请输入身份证有效期开始日期');
						return false;
					}
					if (this.form.person_idcard_end == '' && !this.form.person_idcard_end_is_long) {
						this.$message.error('请输入身份证有效期结束日期，无结束日期请勾选长期');
						return false;
					}
					if (this.form.person_idcard_front_id == '') {
						this.$message.error('请上传法人身份证正面照片');
						return false;
					}
					if (this.form.person_idcard_back_id == '') {
						this.$message.error('请上传法人身份证反面照片');
						return false;
					}
					//进入下一环节
					this.step++;
				} else if (this.step == 1) {
					if (this.form.busi_name == '') {
						this.$message.error('请输入商户简称');
						return false;
					}
					if (this.form.kf_phone == '') {
						this.$message.error('请输入客服电话');
						return false;
					}
					if (this.form.admin_type == 'SUPER') {
						if (this.form.admin_name == '') {
							this.$message.error('请输入超级管理员真实姓名');
							return false;
						}
						if (this.form.admin_idcard == '') {
							this.$message.error('请输入管理员身份证号');
							return false;
						}
					}
					if (this.form.admin_phone == '') {
						this.$message.error('请输入管理员联系电话');
						return false;
					}
					if (this.form.admin_email == '') {
						this.$message.error('请输入联系邮箱地址');
						return false;
					}
					//进入下一环节
					this.step++;
				} else if (this.step == 2) {
					if (this.form.account_bank_name == '') {
						this.$message.error('请选择开户银行');
						return false;
					}
					if (this.form.account_area[0] == '') {
						this.$message.error('请选择开户行所在省');
						return false;
					}
					if (this.form.account_area[1] == '') {
						this.$message.error('请选择开户行所在市');
						return false;
					}
					if (this.form.account_area[2] == '') {
						this.$message.error('请选择开户行所在区');
						return false;
					}
					if (this.form.account_bank_fullname == '') {
						this.$message.error('请输入开户银行全称');
						return false;
					}
					if (this.form.account_bank_no == '') {
						this.$message.error('请输入银行账号');
						return false;
					}
					if (this.form.industry == '') {
						this.$message.error('请选择所属行业');
						return false;
					}
					if (this.form.indset && this.form.indset.is_quali) {
						if (this.form.qual.length == 0) {
							this.$message.error('请按提示上传必要的特殊资质');
							return false;
						}
					}
					this.submit();
				}
				document.getElementsByClassName("father-main")[0].scrollTop = 0;
			},
			prevStep() {
				//返回上一环节
				this.step--;
				document.getElementsByClassName("father-main")[0].scrollTop = 0;
			},
			submit() {
				console.log('apply', this.form)
				if (this.form.admin_type == 'LEGAL') {
					this.form.admin_name = this.form.person_name;
					this.form.admin_idcard = this.form.person_idcard;
				}
				if (this.form.person_idcard_end_is_long) {
					this.form.person_idcard_end = '长期';
				}
				const loading = this.$loading({
				  lock: true,
				  text: '提交中',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
				applyment({
					form_data: JSON.stringify(this.form)
				}).then(res => {
					if (res.code == 0) {
						loading.close();
						this.$message.success('提交成功');
						setTimeout(() => {
							this.$router.go(-1);
						}, 1000)
					} else {
						loading.close();
						this.$notify.error({
						  title: '提交失败',
						  dangerouslyUseHTMLString: true,
						  message: '<strong style="word-break: break-all;">' + res.message + '</strong>',
						  duration: 0
						});
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.container {
		width: 100%;
		border-radius: 4px;
		background-color: #FFFFFF;
	}

	.header {
		padding: 13px 25px;
		border-bottom: 1px solid #EEEEEE;
		display: flex;
		align-items: center;
	}

	.title {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 30px;
	}

	.remark {
		margin-left: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 20px;
	}

	.step-block {
		padding: 35px 80px 45px 55px;
	}

	.step-block>>>.el-step__title {
		margin-left: -20px;
	}

	.forms {}

	.form-title {
		border-left: 3px solid #409EFF;
	}

	.form-title p {
		padding-left: 15px;
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}

	.form1,
	.form2,
	.form4 {
		padding: 30px 200px 1px 40px;
	}

	.form3 {
		padding: 30px 200px 30px 40px;
	}
	
	.forms>>>.el-input.is-disabled .el-input__inner {
		background-color: #FFFFFF;
		border-color: #E4E7ED;
		color: #333333;
		cursor: not-allowed;
	}
	
	.forms >>> .el-form-item {
		display: flex;
		align-items: center;
	}

	.forms>>>.el-form-item__label {
		width: 90px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 22px;
		text-align: left;
	}
	
	.forms >>> .el-input--suffix .el-input__inner {
	    padding-right: 10px;
	}

	.forms >>> .el-input {
		width: 380px;
	}
	
	.forms >>> .el-input__inner {
		color: #333;
	}
	
	.forms >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
	    margin-left: -10px;
	}
	
	.short-input >>>.el-input {
		width: 185px;
		margin-right: 10px;
	}

	.el-upload-1 {
		position: relative;
		width: 300px;
		height: 169px;
		margin-right: 15px;
	}

	.el-upload-1-item {
		width: 300px;
		height: 169px;
		background: #F2F6FC;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
	}

	.el-upload-1-item .el-icon-plus {
		color: #429FFF;
		font-size: 64px;
		font-weight: bold;
	}

	.el-upload-1-img {
		width: 300px;
		height: 169px;
		border-radius: 4px;
		object-fit: contain;
	}

	.el-upload-2 {
		position: relative;
		width: 266px;
		height: 166px;
		margin-right: 15px;
	}

	.el-upload-2-item {
		width: 266px;
		height: 166px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
	}

	.el-upload-2-item img {
		width: 266px;
		height: 166px;
	}

	.el-upload-2-img {
		width: 266px;
		height: 166px;
		border-radius: 4px;
		object-fit: contain;
	}
	
	.el-upload-3 {
		position: relative;
		width: 90px;
		height: 90px;
		display: flex;
		align-items: center;
		margin-right: 15px;
	}
	.el-upload-3 >>> .el-upload-list--picture-card {
		display: flex;
		align-items: center;
	}
	.el-upload-3 >>> .el-upload--picture-card {
		width: 90px;
		height: 90px;
	}
	.el-upload-hide >>> .el-upload--picture-card {
		display: none;
	}
	.el-upload-3 >>> .el-upload-list--picture-card .el-upload-list__item {
	    width: 90px;
	    height: 90px;
	    margin: 0 8px 0px 0;
	}
	.el-upload-3-item {
		width: 90px;
		height: 90px;
		line-height: 100px;
	}
	.el-upload-3-item .el-icon-plus {
		color: #429FFF;
		font-weight: bold;
	}
	.el-upload-tip {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
		white-space: pre-wrap;
	}
	
	.forms >>> .el-button--primary {
		width: 110px;
		background-color: #0486FE;
	}
	
	.forms >>> .el-button--default {
		width: 110px;
	}
</style>
